import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RxDBProviderService } from './survey-embed-bot/rx-db.service';
import { AuthService } from './auth.service';

// Define the reusable fluid motion

@Component({
  imports: [RouterOutlet],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  rxdbService = inject(RxDBProviderService);
  auth = inject(AuthService);
  async ngOnInit(): Promise<void> {
    // await this.rxdbService.init();
    await this.auth.requestPersistence();

    // Existing auth logic...
    const { data } = await this.auth.getSession();
  }
}
